import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import theme from '../../theme';

const CommentContent = ({
  content,
  isDeleted = false,
  deletedText = '삭제된 댓글입니다.',
  mentionedUser = null,
  sx = {},
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Typography
        component="div"
        fontSize={14}
        color={theme.palette.black[6]}
        sx={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
          lineHeight: 1.5,
        }}
      >
        {isDeleted ? (
          deletedText
        ) : (
          <>
            {mentionedUser && (
              <Typography
                component="span"
                fontSize={14}
                fontWeight="bold"
                color={theme.palette.black[9]}
                onClick={() => navigate(`/users/${encodeURIComponent(mentionedUser.nickname)}`)}
                sx={{ cursor: 'pointer', mr: 0.5 }}
              >
                @{mentionedUser.nickname}
              </Typography>
            )}
            {content}
          </>
        )}
      </Typography>
    </Box>
  );
};

export default CommentContent;
